import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import {
  Typography, Box, Modal, makeStyles, Button, ButtonBase
} from '@material-ui/core';

import { Stack, TextField } from '@mui/material';
import { layoutActions } from '../store';
import { APP_NAME, TESLA_SETUP_URL } from '../config/constant';
import moment from 'moment';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '96%',
  maxWidth: '500px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};
const useStyles = makeStyles(() => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  formContainer: {
    display: 'block',
    width: '100%',
  }

}));

const CancelServiceModal = (props) => {
  const { device, open, setOpen, onOk } = props;

  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.session.user);
  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    if (open) {
      dispatch(layoutActions.closeDeviceListMenu());
      setText("")
    }
  }, [open]);

  const [text, setText] = useState("");

  const handleOk = () => {
    const keywordLower = text.toLowerCase()
    const availableKeywords = [`cancel`, `"cancel"`, `'cancel'`] // [`cancel`]
    if (availableKeywords.includes(keywordLower)) {
      console.log(`onOk:::::`)
      onOk()
    } else {
      alert(`Write "Cancel" to cancel services.`)
    }
  }

  const handleBack = () => {
    setOpen(false)
  }

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      console.log('Enter pressed:', event.target.value);
      handleOk()
    }
  }

  const getNextInvoiceDate = () => {
    if (device?.billed_date) {
      const billed_date = Number(device?.billed_date);
      const currentYearMonth = moment().format('YYYY-MM'); // 'YYYY-MM'
      const currentInvoiceDate = `${currentYearMonth}-${`0${billed_date}`.slice(-2)}`; // 'YYYY-MM-DD'
      const nextInvoiceDate = moment(currentInvoiceDate, 'YYYY-MM-DD').add(1, 'month').format('YYYY-MM-DD');
      return nextInvoiceDate;
    }
  }

  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">{APP_NAME}</Typography>
          <Box sx={{ paddingTop: 16 }}>
            <>
              <div>
                <Stack direction={`column`} justifyContent={`center`} alignItems={`center`} spacing={1}>
                  <Typography align='center'>Please settle all balances and credit BEFORE you cancel.</Typography>
                  <Typography align='center'>Your next invoice date is <b>{getNextInvoiceDate()}</b></Typography>
                  <Typography align='center'>Write Cancel below to cancel services.</Typography>
                  <Stack direction={`row`} justifyContent={`center`} alignItems={`center`} style={{ width: '100%' }}>
                    <TextField
                      variant="filled"
                      margin="normal"
                      value={text}
                      onChange={(event) =>
                        setText(event.target.value)
                      }
                      onKeyUp={(event) => handleKeyUp(event)}
                      autoFocus
                    />
                  </Stack>
                  <Stack direction={`row`} justifyContent={`center`} alignItems={`center`} spacing={1} style={{ width: '100%', marginTop: '16px' }}>
                    <Button type="button" color="primary" variant="outlined" onClick={() => handleBack()}>
                      Go Back
                    </Button>
                    <Button type="button" color="primary" variant="contained" onClick={() => handleOk()}>
                      Cancel Service
                    </Button>
                  </Stack>
                </Stack>
              </div>
            </>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default CancelServiceModal;
